import SelectActivityTypes from './SelectActivityTypes';

export default SelectActivityTypes;
